import { LessonTaskStepKeys } from '../../main/constants/lesson-task-step-keys.ts';
import { RootState } from '../../main/store/main.store.ts';
import { LessonTaskStepKey } from '../../main/types/asset/lesson.types.ts';

export const selectCurrentLessonTaskStepKey = (state: RootState): LessonTaskStepKey =>
  state.lesson.currentLessonTaskStepKey ?? LessonTaskStepKeys.DEFAULT_CURRENT;
